import { Avatar, Box } from "@mui/material";
import { epochToDate } from "../../../../../app/common";
import { getInitials } from "../../../../../common/helpers/getInitials";
import { useTranslation } from "react-i18next";

interface Props {
  name: string;
  comment: string;
  timeStamp: number;
  image: string;
}

const SingleComment = ({ name, comment, timeStamp, image }: Props) => {
  const { t } = useTranslation();

  const timeStampConverter = (timeInMs: number) => {
    const startDate = epochToDate(timeInMs);

    const options: Intl.DateTimeFormatOptions = {
      weekday: "short",
      day: "numeric",
      month: "numeric",
      hour: "numeric",
      minute: "numeric",
    };

    const formattedDate = new Date(startDate).toLocaleString("fi-FI", options);

    const [weekday, date, time] = formattedDate.split(" ");

    const capitalizedWeekday =
      weekday.charAt(0).toUpperCase() + weekday.slice(1);
    const formattedTime = time.replace(":", ".");

    return `${capitalizedWeekday} ${date} klo ${formattedTime}`;
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          marginTop: "20px",
        }}
      >
        {image !== "" ? (
          <Box>
            <img
              src={image}
              alt="img"
              style={{
                height: "34px",
                width: "34px",
                borderRadius: "50%",
              }}
            />
          </Box>
        ) : (
          <Avatar
            sx={{
              height: "34px",
              width: "34px",
              bgcolor: "primary.main",
            }}
          >
            {getInitials(name)}
          </Avatar>
        )}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            marginLeft: "12px",
            marginTop: "8px",
          }}
        >
          <Box
            sx={{
              fontSize: "12px",
              fontWeight: "700",
            }}
          >
            {name}
          </Box>
          <Box
            sx={{
              fontSize: "14px",
              fontWeight: "400",
              paddingBottom: "5px",
            }}
          >
            {comment}
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            marginLeft: "auto",
            marginRight: "5px",
            fontSize: "10px",
            fontWeight: "600",
          }}
        >
          {timeStamp !== 0
            ? timeStampConverter(timeStamp)
            : t("hourEntries:timestampNotAvailable")}
        </Box>
      </Box>
    </>
  );
};

export default SingleComment;
